<div class="flex flex-col items-start leading-none">
    <div class="font-bold">{{ activityType | truncate : 24 }}</div>
    <div class="my-2">{{borrowerName | truncate : 24 }}</div>
    <div class="text-lendio-warm-gray-400">{{created}}</div>
</div>
